export default "__VITE_ASSET__69432914__"